import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import Amplify from './services/amplify';

ReactDOM.render(<App />, document.getElementById('root'));
